// extracted by mini-css-extract-plugin
export default {"popconfirm":"styles_popconfirm__HtsQa","button":"styles_button__2w+T4","ant-btn-disabled":"styles_ant-btn-disabled__2Fmaj","custom-button":"styles_custom-button__QndNl"};